module.exports = __webpack_public_path__ + "img/w3_check_circle_black.fb175c9b.png";